import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ButtonSwitchComponent } from './button-switch.component';

@NgModule({
  declarations: [ButtonSwitchComponent],
  imports: [CommonModule],
  exports: [ButtonSwitchComponent],
})
export class ButtonSwitchModule {}
